<template>
  <h1 class="title has-text-centered is-spaced">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <go-to-dashboard-button />

    <span
      >{{ invoicesPackQty }}
      {{ $t("invoicesPack.invoiceTitle") }}&nbsp;&nbsp;</span
    >

    <button
      class="button"
      @click="$emit('get-invoices-pack')"
      :style="c1 ? 'margin-top: 1rem;' : ''"
    >
      <b-icon icon="sync-alt"></b-icon>
    </button>

    <hr />
  </h1>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import { responsive } from "../../mixins/responsive";
import { mask } from "../../mixins/mask";
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  mixins: [common, responsive, mask],

  components: {
    goToDashboardButton
  },

  data() {
    return {
      isLoading: false
    };
  },

  computed: {
    ...mapGetters(["permissions", "invoicesPackQty"]),

    c1() {
      return this.windowWidth < 751 && this.windowWidth > 381;
    },

    filteredData() {
      return this.dropdownList.filter(option => {
        return (
          option
            .toString()
            .toLowerCase()
            .indexOf(this.ms.toLowerCase()) >= 0
        );
      });
    }
  },

  mounted() {
    this.dates = [new Date(), new Date()];
  }
};
</script>

<style scoped>
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
